import React, { useEffect, useMemo, useState } from "react";
import {FormGroup,} from "components/common";
import { Button, Input, Label, ModalFooter } from "reactstrap";
import { Trans } from "react-i18next";
import { Control, LocalForm } from "react-redux-form";
import { useFieldArray, useForm } from "react-hook-form";
import { Controller } from "react-hook-form";
import { NotificationManager } from "react-notifications";


export const Edit = ({
    t,
    setSelectedOption,
    options,
    item,
    control,
    reset,
    setIsRequired,
    client,
    isRequired,
    CreateUpdateColumnSecondModal,
    SetCreateUpdateColumnSecondModal,
    CreateColumnModal,
    SetCreateColumnModal,
    defaultColumnChoices,
    handleModalClose,
    selectedOption,
    list_id,
    getValues,
    namesArray,
    getListColumns,
    CreateUpdateColumnSecondToggle,
}) => {

    const [nameError, setNameExistsError] = useState(false);
    const handleNameChange = (event) => {
        const enteredName = event.target.value.toLowerCase();
        const originalName = item?.name?.toLowerCase();
        setNameExistsError(enteredName !== originalName && namesArray.includes(enteredName));
    };

    const { fields, remove, append } = useFieldArray({
        control,
        name: "column_choices",
        keyName: "key",
    });

    const handleAddChoice = () => {
        append({
            id: fields?.length + 1,
            name: `Choice ${fields?.length + 1}`,
        });
    };

    useEffect(() => {
        const defaultValues = item ? item?.column_choices : defaultColumnChoices;
        reset({
            column_choices: defaultValues,
        });
    }, [item, reset]);

    const handleNextClick = () => {
        SetCreateColumnModal(false);
        SetCreateUpdateColumnSecondModal(true);
    };

    const handleColumnFormUpdateOrCreate = async (values, columnId) => {
        
        let method = 'post';
        let url = `list-details/${list_id}/tracking-list-column`;
        let postData = values;
        const currentChoices = getValues("column_choices");
        if (columnId) {
            url = `${url}/${columnId}`
            const { column_choices, ...valuesWithoutChoices } = values;
            method = 'put';
            
            postData = { column_choices: currentChoices, ...valuesWithoutChoices, id: columnId, type:selectedOption };
        } else {
            postData = { column_choices: currentChoices, ...values, type:selectedOption }
        };

        try {
            await client[method](url, postData);
            NotificationManager.success(t(`Colum ${columnId ? 'updated' : 'created'} successfully`));
            getListColumns();
        } catch (error) {
            if (error.response && error.response.data && error.response.data.error) {
                NotificationManager.error(error.response.data.error);
            } else {
                NotificationManager.error("Something went wrong");
            }
        };
        CreateUpdateColumnSecondToggle();
    };

    const handleChoiceRemove = (id) => {
        const newFields = fields.filter((field) => field?.id !== id);
        reset({
            column_choices: newFields,
        });
    };

    return (
        <>
            <CreateUpdateColumnSecondModal title={item && item.name !== "" ? t("Update Column Details") : t("Define Column Details")}>
                <LocalForm className="col-12" onSubmit={(values) => handleColumnFormUpdateOrCreate(values, item?.id)} initialState={item}>
                    <FormGroup label={t('Name')}>
                        <Control.text
                            model=".name"
                            className="form-control"
                            placeholder={t("Enter name")}
                            onChange={handleNameChange}
                            required
                        />
                        {nameError && <div className="text-danger"><Trans>Column with this name already exists</Trans></div>}
                    </FormGroup>
                    <FormGroup label={t('Description')} className="mt-3">
                        <Control.textarea
                            model=".description"
                            className="form-control"
                            placeholder={t('Enter description')}
                        />
                    </FormGroup>
                    <FormGroup label={t('Field Type')} className="mt-3">
                        <Control.select
                            model=".type"
                            className="form-control"
                            defaultValue={item?.type || selectedOption}
                            onChange={(e) => setSelectedOption(e?.target?.value)}
                        >
                            {options?.map((option) => (
                                <option key={option} value={option}>
                                    {option.charAt(0).toUpperCase() + option.slice(1)}
                                </option>
                            ))}
                        </Control.select>
                    </FormGroup>
                    {(item?.type === "choice" || selectedOption === "choice") && (item?.column_choices?.length > 0 || fields?.length > 0) && (
                        <FormGroup label={t('Choices *')} className="mt-3">
                            <div className="row d-flex align-items-center ml-0">
                                {fields.map((option, index) => {
                                    const n = (v) => `column_choices.${index}.${v}`;
                                    return (
                                        <>
                                            <div className="col-11 my-1" key={index}>
                                                <Controller
                                                    control={control}
                                                    name={n(`name`)}
                                                    render={({ field }) => (
                                                        <Input
                                                            {...field}
                                                            className="form-control"
                                                        />
                                                    )}
                                                />
                                            </div>
                                            <div className="col-1 clickable px-0">
                                                <i className="fa fa-times text-danger" onClick={() => handleChoiceRemove(option?.id)} aria-hidden="true"></i>
                                            </div>
                                        </>
                                    )
                                })}
                            </div>
                            <div className="col mt-2 mr-1">
                                <Button color="primary" className="ml-0" onClick={() => handleAddChoice()}><i className="fa fa-plus mr-1"></i><Trans>Add Choice</Trans></Button>
                            </div>
                        </FormGroup>
                    )}
                    <FormGroup>
                        <div className="d-grid align-items-center mt-3">
                            <div className="d-flex align-items-center ml-4">
                                <Control.checkbox
                                    model=".is_required_field"
                                    checked={isRequired}
                                    onChange={() => setIsRequired(!isRequired)}
                                />
                                <span className="ml-1 mt-1"><Trans>Required</Trans></span>
                            </div>
                            <span className="text-muted small mt-0"><Trans>*Require that this column contains information</Trans></span>
                        </div>
                    </FormGroup>
                    <ModalFooter className="mt-1 pb-1 pt-3 px-0">
                        <Button color="primary" type="submit" disabled={nameError}>
                            <Trans>Save</Trans>
                        </Button>
                        <Button color="outline-secondary" className="mr-0" onClick={handleModalClose}>
                            <Trans>Cancel</Trans>
                        </Button>
                    </ModalFooter>
                </LocalForm>
            </CreateUpdateColumnSecondModal>

            <CreateColumnModal>
                <LocalForm className="">
                    <div className="row">
                        <div className="col-8 d-flex flex-column justify-content-center">
                            <div className="text-center mb-2">
                                <Trans>Create a column</Trans>
                            </div>
                            <div className="text-center">
                                <img src={`/images/streak/${selectedOption}_icon.svg`} />
                            </div>
                            <div className="text-center mt-2">
                                {selectedOption === 'image' && <Trans>Set your image</Trans>}
                                {selectedOption === 'text' && <Trans>Set your text</Trans>}
                                {selectedOption === 'date' && <Trans>Set your date</Trans>}
                                {selectedOption === 'yes_no' && <Trans>Set a choice as yes/no</Trans>}
                                {selectedOption === 'choice' && <Trans>Select your choice</Trans>}
                                {selectedOption === 'textarea' && <Trans>Write your text</Trans>}
                                {selectedOption === 'number' && <Trans>Set your integer field</Trans>}
                                {selectedOption === 'hyperlink' && <Trans>Set your URL</Trans>}
                            </div>
                        </div>
                        <div className="col-4 text-left border-left">
                            <div className={`clickable rounded p-2 ${selectedOption === 'text' && 'bg-light'}`} onClick={() => setSelectedOption('text')}><Trans>Text</Trans></div>
                            <div className={`clickable rounded p-2 ${selectedOption === 'choice' && 'bg-light'}`} onClick={() => setSelectedOption('choice')}><Trans>Choice</Trans></div>
                            <div className={`clickable rounded p-2 ${selectedOption === 'date' && 'bg-light'}`} onClick={() => setSelectedOption('date')}><Trans>Date</Trans></div>
                            <div className={`clickable rounded p-2 ${selectedOption === 'yes_no' && 'bg-light'}`} onClick={() => setSelectedOption('yes_no')}><Trans>Yes/No</Trans></div>
                            <div className={`clickable rounded p-2 ${selectedOption === 'textarea' && 'bg-light'}`} onClick={() => setSelectedOption('number')}><Trans>Number</Trans></div>
                            <div className={`clickable rounded p-2 ${selectedOption === 'number' && 'bg-light'}`} onClick={() => setSelectedOption('textarea')}><Trans>Multiple lines</Trans></div>
                            <div className={`clickable rounded p-2 ${selectedOption === 'hyperlink' && 'bg-light'}`} onClick={() => setSelectedOption('hyperlink')}><Trans>Url</Trans></div>
                            <div className={`clickable rounded p-2 ${selectedOption === 'image' && 'bg-light'}`} onClick={() => setSelectedOption('image')}><Trans>Image</Trans></div>
                        </div>
                    </div>
                </LocalForm>
                <ModalFooter className="mt-2 pb-1 pt-3 px-0">
                    <Button color="primary" onClick={() => handleNextClick()}>
                        <Trans>Next</Trans>
                    </Button>
                    <Button color="outline-secondary" className="mr-0" onClick={() => { SetCreateColumnModal() }}>
                        <Trans>Close</Trans>
                    </Button>
                </ModalFooter>
            </CreateColumnModal>
        </>
    );
};

export default Edit;
